<app-loading-spinner *ngIf="isLoading" [inline]="1"></app-loading-spinner>
<nav class="subnav">
  <h2>Overview</h2>
</nav>

<div class="container container-inner">
  <div class="row">
    <div class="col-12 col-md-12">
      <div class="card mt-3 bg-dark text-white mb-3">
        <img
          src="/assets/img/module-eat-well-470x260.jpg"
          class="card-img-top card-img-top-fh img-mobile"
          alt="Healthy food"
        />
        <img
          src="/assets/img/module-eat-well-930x260.jpg"
          class="card-img-top card-img-top-fh img-desktop"
          alt="Healthy food"
        />
        <div class="card-body text-center">
          <h3 class="card-title card-title-lg">Healthy Eating For Surgery</h3>
          <p class="card-text">
            Welcome to Eat Well! The nutrition module that aims to help you eat healthily in preparation for surgery.
          </p>
        </div>
      </div>
     
      <button
        class="btn btn-primary w-100"
        [routerLink]="['/modules', 'eat-well', 'tracker']"
      >
       
        Nutrition Tracker
      </button>
    </div>
    <div class="col-12" *ngIf="userData">
      <!-- Moved 
      <h4 class="text-center mt-4 mb-2">Nutrition Tracker</h4>
      <div class="card bg-light">
        <div class="card-body">
          <div class="stat">
            <h5 class="stat-title text-center">Daily Scores This Week</h5>
            <div class="days-indicator days-indicator-md text-center">
              <div class="day" *ngFor="let day of eatWellWeekData">
                <div class="day-label">
                  {{ day.date | customDate : "dddd" | slice : 0 : 1 }}
                </div>

                <div
                  class="day-status-lg day-status-circle bg-dark text-white"
                  *ngIf="day.date <= today && day.score > 0"
                >
                  <div class="day-status-title">{{ day.score }}</div>
                </div>
                <div
                  class="day-status-lg day-status-circle bg-dark text-white"
                  *ngIf="day.date <= today && day.score < 1"
                >
                  <div class="day-status-title">-</div>
                </div>
                <div
                  class="day-status-lg day-status-circle bg-dark text-white"
                  *ngIf="day.date > today"
                ></div>
              </div>
            </div>
            <div class="card-total card-total-inline mt-3 mb-2 card-total-light card-total-lg card-total-nb bg-dark">
                <span>{{weekScore}}</span> / <span class="opacity-75">35</span>
              </div>
          </div>

          
        </div>
        <div class="card-footer text-center relative text-dark bg-secondary">
          <a
            [routerLink]="['/activity', 'fit', 'level', '1']"
            class="stretched-link"
            >View &nbsp;
            <span class="icon-wrap more-link text-dark"
              ><fa-icon
                [icon]="['fas', 'circle-chevron-right']"
              ></fa-icon></span
          ></a>
        </div>
      </div>
-->
      <div class="col-12">
        <h4 class="text-center mt-4 mb-2">Module Task List</h4>

        <div class="card bg-light">
          <div class="card-body">
            <ul class="link-list">
              <li>
                <a [routerLink]="['/modules', 'eat-well', 'resources']">
                  <span class="circle-num">1</span>
                  <span class="icon-wrap more-link text-dark"
                    ><fa-icon [icon]="['fas', 'play-circle']"></fa-icon
                  ></span>
                  <span class="link-label"
                    >Welcome to Eat Well</span
                  >
                  <span class="icon-wrap more-link duo-primary-dark"
                    ><fa-icon [icon]="['fad', 'circle-chevron-right']"></fa-icon
                  ></span>
                </a>
              </li>
              <li>
                <a [routerLink]="['/modules', 'eat-well', 'resources', 19]">
                  <span class="circle-num">2</span>
                  <span class="icon-wrap more-link text-dark"
                    ><fa-icon [icon]="['fas', 'play-circle']"></fa-icon
                  ></span>
                  <span class="link-label">
                    Why it's important to Eat Well for surgery	
                   </span>
                  <span class="icon-wrap more-link duo-primary-dark"
                    ><fa-icon [icon]="['fad', 'circle-chevron-right']"></fa-icon
                  ></span>
                </a>
              </li>
              <li>
                <a [routerLink]="['/modules', 'eat-well', 'resources', 20]">
                  <span class="circle-num">3</span>
                  <span class="icon-wrap more-link text-dark"
                    ><fa-icon [icon]="['fas', 'play-circle']"></fa-icon
                  ></span>
                  <span class="link-label"> How to Eat Well for surgery	</span>
                  <span class="icon-wrap more-link duo-primary-dark"
                    ><fa-icon [icon]="['fad', 'circle-chevron-right']"></fa-icon
                  ></span>
                </a>
              </li>
              <li>
                <a [routerLink]="['/modules', 'eat-well', 'resources', 21]">
                  <span class="circle-num">4</span>
                  <span class="icon-wrap more-link text-dark"
                    ><fa-icon [icon]="['fas', 'play-circle']"></fa-icon
                  ></span>
                  <span class="link-label">
                    How to record and monitor my Eat Well progress for surgery	</span>
                  <span class="icon-wrap more-link duo-primary-dark"
                    ><fa-icon [icon]="['fad', 'circle-chevron-right']"></fa-icon
                  ></span>
                </a>
              </li>
              <li>
                <a  [routerLink]="['/modules', 'eat-well', 'tracker']">
                  <span class="circle-num"
                    ><fa-icon [icon]="['far', 'repeat']"></fa-icon
                  ></span>
                  <span class="icon-wrap more-link text-dark"
                    ><fa-icon [icon]="['fas', 'cutlery']"></fa-icon
                  ></span>
                  <span class="link-label"
                    >Add Entries to the Eat Well tracker</span
                  >
                  <span class="icon-wrap more-link duo-primary-dark"
                    ><fa-icon [icon]="['fad', 'circle-chevron-right']"></fa-icon
                  ></span>
                </a>
              </li>
              <li>
                <a  class="pointer" (click)="journalService.onShowJournal('eatWell')">
                  <span class="circle-num"
                    ><fa-icon [icon]="['far', 'repeat']"></fa-icon
                  ></span>
                  <span class="icon-wrap more-link text-dark"
                    ><fa-icon [icon]="['fas', 'book']"></fa-icon
                  ></span>
                  <span class="link-label"
                    >Eat Well Journal</span
                  >
                  <span class="icon-wrap more-link duo-primary-dark"
                    ><fa-icon [icon]="['fad', 'circle-chevron-right']"></fa-icon
                  ></span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
